import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const domainListApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
domainListApiInstance.interceptors.request.use(requestInterceptor);

export default domainListApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/domainListApi.js